import React from 'react';
import { motion } from 'framer-motion';
const painPoints = [{
  emoji: '😰',
  text: 'Tomé la pastilla con retraso y no sé si sigo protegida'
}, {
  emoji: '😨',
  text: 'Un día se me olvidó y entré en pánico total'
}, {
  emoji: '😕',
  text: 'Mi médico me explicó en 2 minutos y salí con más dudas'
}, {
  emoji: '😟',
  text: 'Tengo miedo de los efectos secundarios'
}, {
  emoji: '😳',
  text: 'No sé si mis medicamentos afectan la efectividad'
}, {
  emoji: '😣',
  text: 'He olvidado pastillas y no sé el riesgo real'
}, {
  emoji: '😤',
  text: 'Google me da información contradictoria'
}, {
  emoji: '🤯',
  text: 'Debería saber más sobre lo que meto en mi cuerpo'
}];
export function Problem() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-159">
      <div className="text-center mb-16" data-id="element-160">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-dark mb-4" data-id="element-161">
          ¿Te identificas con alguna de estas situaciones?
        </h2>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-162">
        {painPoints.map((point, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-white p-6 rounded-[16px] shadow-sm hover:shadow-md transition-shadow border border-brand-cardPink/50" data-id="element-163">
            <div className="text-4xl mb-4" data-id="element-164">{point.emoji}</div>
            <p className="text-brand-dark font-medium leading-relaxed" data-id="element-165">
              "{point.text}"
            </p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto bg-gradient-primary p-[2px] rounded-[16px]" data-id="element-166">
        <div className="bg-white rounded-[14px] p-8 text-center" data-id="element-167">
          <p className="text-xl md:text-2xl font-semibold text-brand-dark" data-id="element-168">
            Si dijiste SÍ a cualquiera de estas...{' '}
            <br className="hidden md:block" data-id="element-169" />
            <span className="text-brand-primary" data-id="element-170">
              esta guía fue creada EXACTAMENTE para ti 💜
            </span>
          </p>
        </div>
      </motion.div>
    </section>;
}